const SITE_OWNER = 1;
const ACCOUNT_MANAGER = 2;
const CAMPAIGN_CREATOR = 3;
const PARTNER_MANAGER = 7;

const getRoleName = (roleId, t) => {
  let role = '';

  switch (roleId) {
    case SITE_OWNER:
      role = t('users.role.site_owner');
      break;
    case ACCOUNT_MANAGER:
      role = t('users.role.account_manager');
      break;
    case CAMPAIGN_CREATOR:
      role = t('users.role.campaign_creator');
      break;
    case PARTNER_MANAGER:
      role = t('users.role.partner_manager');
      break;
    default:
      // eslint-disable-next-line no-console
      console.error(`Unknown role ${roleId}`);
  }

  return role;
};

export default {
  SITE_OWNER,
  ACCOUNT_MANAGER,
  CAMPAIGN_CREATOR,
};

export { getRoleName };
